// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9Z_23","top":"styles_top__C7YOw"};